import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import { SearchCollaboratorsComponent } from 'src/app/components/search-collaborators/search-collaborators.component';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-collaborators-select-extends',
  templateUrl: './collaborators-select-extends.component.html',
  styleUrls: ['./collaborators-select-extends.component.css']
})
export class CollaboratorsSelectExtendsComponent {
  @Output() onSubmitEvent = new EventEmitter<string>();
  @ViewChild(SearchCollaboratorsComponent) SearchCollaboratorsComponent: any;

  submitted: boolean = false;
  isCollaboratorSelected:boolean = false;
  collaboratorSelected: any = {};
  book: any = {};

  constructor(
    public fb: FormBuilder,
    private serviceHotelService: ServicehotelService,
    private alertifyMsg: AlertifyHelper
  ) {
  }

  init(data:any) {
    this.book = data;
    setTimeout(() => {
      this.SearchCollaboratorsComponent.focused();
    }, 500);
  }

  selectedCollaboratorsSearch(item_: any) {
    this.isCollaboratorSelected = true;
    this.collaboratorSelected = item_;
  }

  removeCollaborator() {
    this.isCollaboratorSelected = false;
    this.collaboratorSelected = {};    
    setTimeout(() => {
      this.SearchCollaboratorsComponent.focused();
    }, 250);
  }

  onSubmit() {
    if(this.isCollaboratorSelected){
      let data:any = {}
      data.collaborator = this.collaboratorSelected;
      data.book = this.book;
      this.onSubmitEvent.emit(data);
      (<any>$('#openExtendsSelectCollaborators')).modal('hide');
      this.resetForm();
    }else{
      this.alertifyMsg.warning("Debe seleccionar el colaborador");
    }
  }

  resetForm() {
    this.isCollaboratorSelected = false;
    this.collaboratorSelected = {};    
  }

  close() {
    this.resetForm();
  }
}
